export default "__VITE_ASSET__CJnJ9BRh__"